import DEFAULT_PALETTE_LIGHT from './Palette/default_light'
import DEFAULT_PALETTE_DARK from './Palette/default_dark'

import DEFAULT_TYPOGRAPHY from './Typography/default'

import DEFAULT_THEME from './default'

const AVAILABLE_THEMES = ['default']
const AVAILABLE_MODES = ['light', 'dark']

let BASE_THEME = localStorage.getItem('theme.theme') ?? 'default'
let BASE_MODE = localStorage.getItem('theme.mode') ?? 'light'

if (!AVAILABLE_THEMES.includes(BASE_THEME)) BASE_THEME = 'default'
if (!AVAILABLE_MODES.includes(BASE_MODE)) BASE_THEME = 'light'

const LOADED = {
    palette: {
        default: {
            light: DEFAULT_PALETTE_LIGHT,
            dark: DEFAULT_PALETTE_DARK
        }
    },
    typography: {
        default: DEFAULT_TYPOGRAPHY
    },
    theme: {
        default: DEFAULT_THEME
    }
}

const THEME = {
    palette: LOADED.palette[BASE_THEME][BASE_MODE],
    typography: LOADED.typography[BASE_THEME],
    theme: LOADED.theme[BASE_THEME]
}

export default THEME